<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m1TUfG/tc-custom/9780811744973.jpg?1705766126621" alt="This image is the cover for the book Lines of Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lines of Fire
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling military analyst offers a collection of essays covering a generation of geopolitics and military policy.</b><br/>  <br/> For decades, Ralph Peters has been the most provocative and visionary American writer on military affairs, strategy, security, and intelligence. In that time, he predicted every major trend that has plagued the post-Cold-War world. A career military officer and acclaimed author, he has faced issues ranging from the explosion of religious terrorism to the fatal weaknesses of our intelligence system and our dangerous over-reliance on technology. <br/><br/> Now Peters delves into these and other enduringly vital themes in this definitive, career-spanning collection of his writings. <i>Lines of Fire</i> is an indispensable volume for understanding today’s crises—and tomorrow’s. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ralph Peters
      </h2>
      
      <p class="authorDescription body article">Fox News Strategic Analyst Ralph Peters is the author of 27 books, including bestselling and prize-winning novels.  He has experience in over 70 countries and, as a journalist, has covered multiple conflicts.  His work has appeared in a wide range of publications and he serves on the advisory board of Armchair General magazine. He lives in Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stackpole Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55918ba5